import { Report } from 'api/types'
import { Icon } from 'components/Icon'
import { formatDateTime } from 'lib/format'
import { t } from 'lib/i18n'

/** Warns that a report was sent back for changes; shown on the editor and on the engineer's Today page. */
export const ReturnedBanner = ({ report }: { report: Report }) => {
  if (report.workflow !== 'RETURNED' || !report.returnNote) return null
  return (
    <div className="alert alert--warning" role="status">
      <Icon name="undo" />
      <div>
        <strong>
          {report.returnedByName
            ? t(`تقرير للمراجعة بواسطة ${report.returnedByName}`, `Report for review by ${report.returnedByName}`)
            : t('تقرير للمراجعة', 'Report for review')}
          {report.returnedAt ? ` · ${formatDateTime(report.returnedAt)}` : ''}
        </strong>
        <p>{report.returnNote}</p>
      </div>
    </div>
  )
}
